export const DOWNLOAD_PROCESS_STATEMENT_RTF_FAILURE = 'DOWNLOAD_PROCESS_STATEMENT_RTF_FAILURE';

export const downloadProcessStatementRtfFileFailure = error => ({
    type: DOWNLOAD_PROCESS_STATEMENT_RTF_FAILURE,
    payload: error,
    error: true,
});
